<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">       
    	<el-form :inline="true" class="backborder1 demo-form-inline" size="small">
			<el-form-item>
    			<el-date-picker v-model="query.date1" type="daterange" range-separator="至" start-placeholder="订单创建开始日期" end-placeholder="订单创建结束日期" value-format="yyyy-MM-dd" @change="query.ischange=true" :unlink-panels="false" style="width:100%"></el-date-picker>
    		</el-form-item>
			<el-form-item>
    			<el-date-picker v-model="query.date2" type="daterange" range-separator="至" start-placeholder="订单审核开始日期" end-placeholder="订单审核结束日期" value-format="yyyy-MM-dd" @change="query.ischange=true" :unlink-panels="false" style="width:100%"></el-date-picker>
    		</el-form-item>
			<el-form-item style="width:10%">
    			<el-select v-model="query.status" clearable filterable remote reserve-keyword placeholder="请选择订单状态" @change="query.ischange=true">
		          	<el-option v-for="(item,index) in statuslists" :key="index" :label="item.name" :value="item.id"></el-option>
		        </el-select> 
    		</el-form-item>
			<el-form-item>
    			<el-input type="text" size="small" v-model="query.warehousecode" clearable placeholder="请填写仓库代码" @change="query.ischange=true" @keyup.enter.native="getlists"/>
    		</el-form-item>
			<el-form-item>
    			<el-input type="text" size="small" v-model="query.suppliercode" clearable placeholder="请填写供应商代码" @change="query.ischange=true" @keyup.enter.native="getlists"/>
    		</el-form-item>
			<el-form-item>
    			<el-input type="text" size="small" v-model="query.code" clearable placeholder="请填写采购订单编号" @change="query.ischange=true" @keyup.enter.native="getlists"/>
    		</el-form-item>
			<el-form-item>
    			<el-button type="primary" size="small" circle icon="el-icon-search" @click="getlists" />
    		</el-form-item>
		</el-form>

		<el-tag type="danger" size="small" style="margin-top:10px">温馨提示：以下采购单数据来源于管易云，如查看过程中出现不展示商品数据信息的请自行将系统的商品信息和管易云的进行匹配</el-tag>

		<div class="backborder2" style="margin-top:10px">
	    	<el-table ref="orderTable" :data="orderlists" style="width: 100%" v-loading="query.loading" tooltip-effect="dark">
		    	<el-table-column type="expand">
		    		<template slot-scope="props">
			    		<el-table :data="props.row.goods">
				            <el-table-column prop="name" label="商品名称"></el-table-column>
				            <el-table-column prop="spec" label="规格" width="120" align="center"></el-table-column>
				            <el-table-column prop="number" label="采购数量" width="120" align="center"></el-table-column>
							<el-table-column prop="leastnumber" label="未入库数量" width="120" align="center"></el-table-column>
							<el-table-column prop="price" label="实际进价" width="120" align="center"></el-table-column>
							<el-table-column prop="total" label="小计" width="120" align="center"></el-table-column>
							<el-table-column prop="tax_rate" label="税率" width="120" align="center"></el-table-column>
			            </el-table>
		            </template>
		    	</el-table-column>
		    	<el-table-column label="采购单号">
					<template slot-scope="props">
						<div style="float:left;width:100%">
							<span style="float:left;width:100%">{{props.row.documents}}</span>
						</div>
						<div style="float:left;width:100%;font-size:12px;color:#999999">供应商家：{{props.row.supplier}}</div>
						<div style="float:left;width:100%;font-size:12px;color:#999999">采购仓库：{{props.row.warehouse}}</div>
					</template>
				</el-table-column>
				<el-table-column label="采购商品数" prop="numstotal" width="150" align="center" />
				<el-table-column label="采购小计" prop="total" width="150" align="center" />
		        <el-table-column label="状态" width="150" align="center">
		        	<template slot-scope="props">
		        		<div>{{props.row.status}}</div>
		        	</template>
		        </el-table-column>
				<el-table-column label="创建时间" prop="inputtime" width="200" align="center" />
				<el-table-column label="审核时间" prop="approve_date" width="200" align="center" />
				<el-table-column label="备注" prop="note" width="200" align="center" />
		        
		    </el-table>
		    <div class="block">
	        	<!--分页begin-->
	            <el-pagination
		            @size-change="orderPageSizeChange"
		            @current-change="orderPageCurrentChange"
		            :current-page="query.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="query.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="orderrows">
	            </el-pagination>
	            <!--分页end-->
	      	</div>
		</div>

    </div>
    </transition>       
</template>

<script>

export default {
    data () {
	    return {
	        url:this.GLOBAL.domain+"Kingdeecloud/index",
	        transitionshow:true,
	        actionauth:[],
			query: {
	        	act:'orderlistskingdee',
	        	token:this.$cookies.get('token'),
	        	date1:[],
				date2:[],
				warehousecode:'',
				suppliercode:'',
				code:'',
				status:'',
	        	p:1,
	        	rollpage:10,
				loading:false,
				ischange:false,
	        },
			orderlists:[],
			orderrows:0,
			statuslists:[{id:1,name:'未审核'},{id:2,name:'已审核'}],
	    }
    },
  
    mounted(){
    	this.getactionauth(); //获取权限设置 
		this.getlists(); //获取订单信息列表
    },
  
    methods:{ 

	    /** 获取操作功能权限 **/
  	    getactionauth() {
    	    var data =this.$cookies.get('actionauth');
    	    data=JSON.parse(data);
            this.actionauth=data;
        },

		/** 获取订单信息列表 **/
		getlists() {
			if(this.query.ischange==true) {
	    		this.query.p=1;
	    		this.query.rollpage=10;
	    	}
	    	
	    	this.query.loading=true;
	    	var resource = this.$resource(this.url);
	        resource.save(this.query).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.query.loading=false;
		        }else{
		            this.orderlists = JSON.parse(Base64.decode(res.data.Data));
		            this.orderrows=parseInt(res.data.count);
				    if(this.query.ischange==true) this.query.ischange=false; 
				    this.query.loading=false;                   
		        }
	        }).catch((res) => {
	            this.query.loading=false;
	        });	    
		},

		orderPageSizeChange(val) {
        	this.query.rollpage = val;
        	this.getlists();
	    },
	    orderPageCurrentChange(val) {
	        this.query.p = val;
	        this.getlists();
	    },


    }
}
</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/purchase/orderkingdee.vue